import script from "./CommonTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonTable.vue?vue&type=script&setup=true&lang=ts"

import "./CommonTable.vue?vue&type=style&index=0&id=4d1ae4bf&lang=scss"

const __exports__ = script;

export default __exports__